import { Component, Input, OnInit } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-exactonline',
  templateUrl: './userapi-exactonline.component.html'
})
export class UserApiExactOnlineComponent  extends AbstractUserApiModalComponent implements OnInit {
  @Input() userApi: UserAPI;

  ngOnInit(): void {
    if (this.userApi) {
      this.userApi.valid = this.userApi.url !== undefined;
    }
  }
}
